import { graphql, useStaticQuery } from 'gatsby';

const useJobs = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpPage(filter: {template: {templateName: {eq: "Job"}}}, limit: 10) {
        edges {
          node {
            id
            slug
            template {
              templateName
              ... on WpTemplate_Job {
                templateName
                templateLegal {
                  tagline
                  lastUpdated
                  fieldGroupName
                }
              }
            }
            title
            uri
          }
        }
      }
    }
  `);

  return data;
};

export default useJobs;
